import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

import { breakpoints, Tab } from "@luce/ui";

import { useTabNavigate } from "./use-tab-navigate";

type Align = "start" | "evenly";

interface Props {
  items: {
    label: string;
    href: string;
  }[];
  active?: string;
  align?: Align;
}

/**
 * A route's tabs: the design system's Tab, where picking another tab goes to
 * its href as the router's Link did. "start" stretches the tabs below the md
 * breakpoint and packs them left from it; "evenly" stretches them everywhere.
 * For tabs that switch a value on one screen, use Tab itself.
 */
export function NavTabs({ items, active, align = "start" }: Props) {
  const navigate = useTabNavigate();
  // The window's width, not `isDesktop`: on native that's always false, and
  // the copy's `md:` packed the tabs on a tablet too
  const { width } = useWindowDimensions();
  return (
    <Tab
      items={items.map(({ label, href }) => ({ label, value: href }))}
      active={active ?? ""}
      onChange={(href) => {
        if (href !== active) navigate(href);
      }}
      fullWidth={align === "evenly" || width < breakpoints.md}
    />
  );
}
